import { render, staticRenderFns } from "./DataItem.vue?vue&type=template&id=6e9399ea&scoped=true"
import script from "./DataItem.vue?vue&type=script&lang=js"
export * from "./DataItem.vue?vue&type=script&lang=js"
import style0 from "./DataItem.vue?vue&type=style&index=0&id=6e9399ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9399ea",
  null
  
)

export default component.exports